import { render, staticRenderFns } from "./DeleteConfirmPopup.vue?vue&type=template&id=097e5451"
import script from "./DeleteConfirmPopup.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmPopup.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmPopup.vue?vue&type=style&index=0&id=097e5451&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports